import type { Focus } from '../types';

export interface FocusLanguage {
  /** Storage value retained for historical/database compatibility. */
  canonical: Focus;
  /** Prompt-facing concept; deliberately excludes UI possessives. */
  internal: 'love_and_relationships' | 'money_and_career' | 'purpose_and_direction' | 'healing_and_inner_peace' | 'whole_path';
  ui: string;
  heading: string;
  prose: string;
  bridgeTheme: string;
  keywords: string[];
}

export const FOCUS_LANGUAGE: Record<Focus, FocusLanguage> = {
  love_and_relationships: { canonical:'love_and_relationships', internal:'love_and_relationships', ui:'Love and Relationships', heading:'Love and Relationships', prose:'love and relationships', bridgeTheme:'love, trust, and emotional connection', keywords:['love','trust','connection'] },
  money_and_career: { canonical:'money_and_career', internal:'money_and_career', ui:'Money and Career', heading:'Money and Career', prose:'money and career', bridgeTheme:'money, career, and important decisions', keywords:['money','career','decisions'] },
  purpose_and_direction: { canonical:'purpose_and_direction', internal:'purpose_and_direction', ui:'Purpose and Direction', heading:'Purpose and Direction', prose:'purpose and direction', bridgeTheme:'purpose, timing, and your next direction', keywords:['purpose','timing','direction'] },
  healing_and_inner_peace: { canonical:'healing_and_inner_peace', internal:'healing_and_inner_peace', ui:'Healing and Inner Peace', heading:'Healing and Inner Peace', prose:'healing and inner peace', bridgeTheme:'emotional healing, boundaries, and inner peace', keywords:['healing','boundaries','peace'] },
  my_whole_path: { canonical:'my_whole_path', internal:'whole_path', ui:'My Whole Path', heading:'Whole Path', prose:'your whole path', bridgeTheme:'love, direction, personal growth, and major decisions', keywords:['love','direction','growth','decisions'] },
};

export function focusLanguage(value: string): FocusLanguage {
  return FOCUS_LANGUAGE[value as Focus] ?? FOCUS_LANGUAGE.my_whole_path;
}

export function hasMalformedFocusPossessive(value: string): boolean {
  return /\b(?:your|in|for)\s+my\b/iu.test(value);
}
